import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const opeAuthMstRepository = RepositoryFactory.get("opeAuthMst");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setOpeAuthMst(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadOpeAuthMst(context, screenId) {
    const list = await opeAuthMstRepository.list(screenId);
    if (list.status < 300) {
      context.commit("setOpeAuthMst", list.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
